/* SAHICHARAN — theme.js (vanilla, no dependencies) */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;
  if (!window.Sahicharan) window.Sahicharan = {};
  var S = window.Sahicharan;

  /* ---------- Utilities ---------- */
  S.qs = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  S.qsa = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  S.on = function (el, ev, fn) { if (el) el.addEventListener(ev, fn); };
  S.trapFocus = function (container) {
    var focusables = S.qsa('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])', container);
    if (!focusables.length) return;
    var first = focusables[0], last = focusables[focusables.length - 1];
    container.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    first.focus();
  };

  /* ---------- Header: scroll state ---------- */
  function initHeader() {
    var header = S.qs('.site-header');
    if (!header) return;
    var threshold = 24, ticking = false;
    function update() {
      header.classList.toggle('is-scrolled', window.scrollY > threshold);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
    var searchToggle = S.qs('[data-search-toggle]');
    var searchBar = S.qs('[data-search-bar]');
    if (searchToggle && searchBar) {
      searchToggle.addEventListener('click', function () {
        var open = searchBar.classList.toggle('is-open');
        searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) { var input = S.qs('input[type="search"]', searchBar); if (input) input.focus(); }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && searchBar.classList.contains('is-open')) { searchBar.classList.remove('is-open'); searchToggle.setAttribute('aria-expanded', 'false'); } });
    }
  }

  /* ---------- Drawers (menu, cart) ---------- */
  S.openDrawer = function (id) {
    var drawer = document.getElementById(id);
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    S.trapFocus(S.qs('.drawer__panel', drawer) || drawer);
  };
  S.closeDrawer = function (id) {
    var drawer = document.getElementById(id);
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!S.qs('.drawer.is-open')) document.body.classList.remove('drawer-open');
  };
  function initDrawers() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-open-drawer]');
      if (opener) { e.preventDefault(); S.openDrawer(opener.getAttribute('data-open-drawer')); return; }
      var closer = e.target.closest('[data-close-drawer]');
      if (closer) { e.preventDefault(); S.closeDrawer(closer.closest('.drawer').id); return; }
      if (e.target.classList && e.target.classList.contains('drawer__backdrop')) { S.closeDrawer(e.target.closest('.drawer').id); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') S.qsa('.drawer.is-open').forEach(function (d) { S.closeDrawer(d.id); });
    });
  }

  /* ---------- Scroll animations ---------- */
  var io;
  function initAnimations() {
    if (reduceMotion || root.classList.contains('no-anim')) {
      S.qsa('[data-animate]').forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    if (!('IntersectionObserver' in window)) { S.qsa('[data-animate]').forEach(function (el) { el.classList.add('is-visible'); }); return; }
    io = io || new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting && entry.intersectionRatio <= 0) return;
        var group = entry.target.parentElement && entry.target.parentElement.hasAttribute('data-stagger') ? entry.target.parentElement : null;
        if (group) {
          // Reveal the whole staggered group at once (keeps horizontal scrollers coherent on mobile)
          S.qsa('[data-animate]', group).forEach(function (el) { el.classList.add('is-visible'); io.unobserve(el); });
        } else { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    S.qsa('[data-animate]:not(.is-visible)').forEach(function (el) { io.observe(el); });
    S.qsa('[data-stagger]').forEach(function (group) {
      S.qsa(':scope > *', group).forEach(function (child, i) { child.style.setProperty('--i', i); });
    });
    S.qsa('.hero').forEach(function (hero) {
      if (hero.getAttribute('data-hero-animate') !== 'false') hero.classList.add('is-animated');
      requestAnimationFrame(function () { hero.classList.add('is-loaded'); });
    });
  }

  /* ---------- Parallax (subtle, rAF, opt-in) ---------- */
  function initParallax() {
    var items = S.qsa('[data-parallax]');
    if (!items.length || reduceMotion) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      items.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        var progress = (rect.top + rect.height / 2 - vh / 2) / vh; // -1..1
        var amount = parseFloat(el.getAttribute('data-parallax')) || 8;
        el.style.setProperty('--parallax-y', (progress * -amount) + '%');
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Facets (collection filters) ---------- */
  function initFacets() {
    var form = S.qs('[data-facets-form]');
    if (!form) return;
    var toggle = S.qs('[data-facets-toggle]');
    if (toggle) toggle.addEventListener('click', function () { var f = form.closest('.facets'); var open = f.classList.toggle('is-open'); toggle.setAttribute('aria-expanded', open); });
    var timer;
    form.addEventListener('change', function (e) {
      if (e.target.matches('input[type="checkbox"], select')) { clearTimeout(timer); timer = setTimeout(function () { form.requestSubmit ? form.requestSubmit() : form.submit(); }, 250); }
    });
    var sort = S.qs('[data-sort-select]');
    if (sort) sort.addEventListener('change', function () {
      var url = new URL(window.location.href); url.searchParams.set('sort_by', sort.value); url.searchParams.delete('page'); window.location.href = url.toString();
    });
  }

  /* ---------- Quantity inputs (global) ---------- */
  function initQuantity() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-change]');
      if (!btn) return;
      var wrap = btn.closest('.quantity'); var input = S.qs('input', wrap); if (!input) return;
      var step = parseInt(btn.getAttribute('data-qty-change'), 10) || 1;
      var min = parseInt(input.min, 10) || 0; var max = input.max ? parseInt(input.max, 10) : Infinity;
      var val = Math.min(max, Math.max(min, (parseInt(input.value, 10) || 0) + step));
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------- Cart (drawer + page) ---------- */
  S.cart = {
    sections: function () { return ['cart-drawer', 'cart-icon-bubble']; },
    renderSections: function (sections) {
      if (!sections) return;
      Object.keys(sections).forEach(function (id) {
        var html = new DOMParser().parseFromString(sections[id], 'text/html');
        if (id === 'cart-drawer') {
          var target = S.qs('#CartDrawer [data-cart-drawer-content]');
          var fresh = S.qs('[data-cart-drawer-content]', html);
          if (target && fresh) target.innerHTML = fresh.innerHTML;
        } else if (id === 'cart-icon-bubble') {
          S.qsa('[data-cart-icon-bubble]').forEach(function (b) { var f = S.qs('.shopify-section', html); if (f) b.innerHTML = f.innerHTML; });
        }
      });
    },
    setLoading: function (state) { var d = document.getElementById('CartDrawer'); if (d) d.classList.toggle('is-loading', !!state); },
    add: function (formData) {
      S.cart.setLoading(true);
      formData.append('sections', S.cart.sections().join(','));
      formData.append('sections_url', window.location.pathname);
      return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          S.cart.setLoading(false);
          if (data.status) { throw new Error(data.description || data.message || 'Could not add to cart'); }
          S.cart.renderSections(data.sections);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
          return data;
        });
    },
    change: function (line, quantity) {
      S.cart.setLoading(true);
      var body = { line: line, quantity: quantity, sections: S.cart.sections(), sections_url: window.location.pathname };
      return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          S.cart.setLoading(false);
          if (data.status) { throw new Error(data.description || data.message || 'Could not update cart'); }
          S.cart.renderSections(data.sections);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
          return data;
        });
    }
  };
  function initCart() {
    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-line-qty]');
      if (!input) return;
      var line = parseInt(input.getAttribute('data-cart-line-qty'), 10);
      var qty = Math.max(0, parseInt(input.value, 10) || 0);
      if (input.closest('[data-cart-page]')) {
        var f = input.closest('form'); if (f) { f.requestSubmit ? f.requestSubmit() : f.submit(); }
        return;
      }
      S.cart.change(line, qty).catch(function (err) { S.cart.error(err.message); });
    });
    document.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-cart-remove]');
      if (!rm) return;
      if (rm.closest('[data-cart-page]')) return; // native link on cart page
      e.preventDefault();
      S.cart.change(parseInt(rm.getAttribute('data-cart-remove'), 10), 0).catch(function (err) { S.cart.error(err.message); });
    });
    S.cart.error = function (msg) { var el = S.qs('#CartDrawer [data-cart-error]'); if (el) { el.textContent = msg; el.hidden = false; } };
  }

  /* ---------- Newsletter / forms: inline status focus ---------- */
  function initForms() {
    var status = S.qs('.form-status[data-autofocus]');
    if (status) status.scrollIntoView({ block: 'center' });
  }

  /* ---------- Init ---------- */
  function init() {
    initHeader(); initDrawers(); initAnimations(); initParallax(); initFacets(); initQuantity(); initCart(); initForms();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* Theme editor: re-run animations for reloaded sections */
  document.addEventListener('shopify:section:load', function (e) {
    S.qsa('[data-animate]', e.target).forEach(function (el) { el.classList.add('is-visible'); });
    S.qsa('.hero', e.target).forEach(function (h) { h.classList.add('is-loaded', 'is-animated'); });
    initHeader();
  });
  document.addEventListener('shopify:section:select', function (e) {
    S.qsa('[data-animate]', e.target).forEach(function (el) { el.classList.add('is-visible'); });
  });
})();
